import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

const initialState = {
  items: JSON.parse(localStorage.getItem('compareItems')) || [], // Load compare items from local storage or initialize as empty
};

const compareSlice = createSlice({
  name: 'compare',
  initialState,

  reducers: {
    //Reducer to add or remove item to/from Compare
    toggleCompareItem: (state, action) => {
      // Check if the ID exists in Compare Items
      const itemExists = state.items.find(
        (item) => item.id === action.payload.id
      );

      if (itemExists) {
        // Remove product from compare list
        state.items = state.items.filter(
          (item) => item.id !== action.payload.id
        );
        toast.info(`${action.payload.title} removed from Compare!`, {
          position: 'top-center',
        }); // Show info message
      } else {
        // Add product to compare list
        state.items.push(action.payload);
        toast.success(`${action.payload.title} added to Compare!`, {
          position: 'top-center',
        });
      }

      localStorage.setItem('compareItems', JSON.stringify(state.items)); // Save the update Compare items to local storage
    },

    //Reducer to clear compare
    clearCompare: (state) => {
      state.items = [];
      localStorage.removeItem('compareItems'); // Save updated state to localStorage
    },
  },
});

export const { toggleCompareItem, clearCompare } = compareSlice.actions;
export default compareSlice.reducer;
